module.exports = __webpack_public_path__ + "media/images/download-light-67a63693.svg";